import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Simplify } from "@/prismicio-types";
import { Content } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import React from "react";

type Props = {
  data: Simplify<Content.CharitiesHelplinesSliceDefaultPrimaryHelplinesItem>;
};

export default function HelplineCard({ data }: Props) {
  return (
    <Card className="shadow-none border-none bg-[#EBF7FF] text-primary">
      <CardHeader>
        <CardTitle className="text-xl font-semibold">{data.title}</CardTitle>
      </CardHeader>

      <CardContent className="font-merriweather">
        <PrismicRichText
          field={data.description}
          components={{
            paragraph: ({ children }) => <p>{children}</p>,
          }}
        />
      </CardContent>
    </Card>
  );
}
